import { render } from "./support-content.vue?vue&type=template&id=e9572eca&scoped=true&ts=true&lang=pug"
import script from "./support-content.vue?vue&type=script&lang=ts"
export * from "./support-content.vue?vue&type=script&lang=ts"

import "./support-content.vue?vue&type=style&index=0&id=e9572eca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9572eca"]])

export default __exports__